import * as React from 'react';

import { cn, Grid } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $itemsInterfaceShowPricing } from '../_state';
import { getItemRowGridCols } from '../layout';
import { ItemHeaderCell } from '../layout/ItemHeaderCell';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ ITEMS HEADER ⚛️ ⚛️ ⚛️
//
export const ItemsHeader: React.FC = () => {
  const t = useTranslations();
  const columns = t.scaleTicketPro.columns;

  // Atoms
  const showPricing = useAtomValue($itemsInterfaceShowPricing);

  const gridClassName = getItemRowGridCols(showPricing);

  return (
    <Grid
      className={cn(
        '@ItemsHeader w-full gap-3 border-b border-neutral/30 px-2',
        gridClassName,
      )}
    >
      <ItemHeaderCell>{columns.material}</ItemHeaderCell>
      <ItemHeaderCell>{columns.grossWeight}</ItemHeaderCell>
      <ItemHeaderCell>{columns.tareWeight}</ItemHeaderCell>
      <ItemHeaderCell>{columns.netWeight}</ItemHeaderCell>
      {showPricing && (
        <>
          <ItemHeaderCell>{columns.unitPrice}</ItemHeaderCell>
          <ItemHeaderCell>{columns.pricingUnit}</ItemHeaderCell>
          <ItemHeaderCell>{columns.estimatedTotal}</ItemHeaderCell>
        </>
      )}
      <ItemHeaderCell />
      <ItemHeaderCell />
      <ItemHeaderCell />
    </Grid>
  );
};
